export const HR_PERMISSION_KEYS = {
  ASSET_VIEW: "hr_asset_view",
  ASSET_MANAGE: "hr_asset_manage",
  ASSET_REPORT: "hr_asset_report",
  STAFF_LOAN_VIEW: "hr_staff_loan_view",
  STAFF_LOAN_MANAGE: "hr_staff_loan_manage",
  STAFF_LOAN_SETTINGS: "hr_staff_loan_settings",
};

export const HR_ASSET_VIEW_PERMISSIONS = [
  HR_PERMISSION_KEYS.ASSET_VIEW,
  HR_PERMISSION_KEYS.ASSET_MANAGE,
];

export const HR_ASSET_MANAGE_PERMISSIONS = [
  HR_PERMISSION_KEYS.ASSET_MANAGE,
];

export const HR_ASSET_REPORT_PERMISSIONS = [
  HR_PERMISSION_KEYS.ASSET_VIEW,
  HR_PERMISSION_KEYS.ASSET_REPORT,
  HR_PERMISSION_KEYS.ASSET_MANAGE,
];

export const HR_STAFF_LOAN_VIEW_PERMISSIONS = [
  HR_PERMISSION_KEYS.STAFF_LOAN_VIEW,
  HR_PERMISSION_KEYS.STAFF_LOAN_MANAGE,
  HR_PERMISSION_KEYS.STAFF_LOAN_SETTINGS,
  "hr_manage_salary",
];

export const HR_STAFF_LOAN_MANAGE_PERMISSIONS = [
  HR_PERMISSION_KEYS.STAFF_LOAN_MANAGE,
  "hr_manage_salary",
];

export const HR_STAFF_LOAN_SETTINGS_PERMISSIONS = [
  HR_PERMISSION_KEYS.STAFF_LOAN_SETTINGS,
  HR_PERMISSION_KEYS.STAFF_LOAN_MANAGE,
  "hr_manage_salary",
];

export const HR_PERMISSION_PRESETS = [
  {
    name: HR_PERMISSION_KEYS.ASSET_VIEW,
    display_name: "HR Asset - View",
    group: "HR Asset",
    description: "Akses melihat menu dan data asset HR.",
  },
  {
    name: HR_PERMISSION_KEYS.ASSET_MANAGE,
    display_name: "HR Asset - Manage",
    group: "HR Asset",
    description: "Akses membuat, mengubah, dan menghapus master asset.",
  },
  {
    name: HR_PERMISSION_KEYS.ASSET_REPORT,
    display_name: "HR Asset - Report",
    group: "HR Asset",
    description: "Akses melihat dashboard dan laporan asset.",
  },
  {
    name: HR_PERMISSION_KEYS.STAFF_LOAN_VIEW,
    display_name: "HR Staff Loan - View",
    group: "HR Staff Loan",
    description: "Akses melihat data kasbon staff.",
  },
  {
    name: HR_PERMISSION_KEYS.STAFF_LOAN_MANAGE,
    display_name: "HR Staff Loan - Manage",
    group: "HR Staff Loan",
    description: "Akses membuat pengajuan dan memproses approval/pencairan kasbon.",
  },
  {
    name: HR_PERMISSION_KEYS.STAFF_LOAN_SETTINGS,
    display_name: "HR Staff Loan - Settings",
    group: "HR Staff Loan",
    description: "Akses mengatur kebijakan kasbon.",
  },
];
